export default __webpack_public_path__ + "static/cost-of-tplo-v2-470242cf5ce8aa19abc53917a42ddc4d.png";